export default {
  form: {
    amount: {
      label: 'Preț',
    },
    threshold: {
      label: 'Vânzări lunare',
    },
    has_pricing_tiers: {
      label: 'Prețul variază în funcție de vânzările lunare',
    },
    tax_included: {
      label: 'Taxă inclusă',
    },
  },
  buttons: {
    add_tier: 'Adaugă nivel',
  },
};
